// Ревизия волны ИИ-редактора: КАНОНИЧНЫЙ путь '@/api/client', как у соседей
// (aiFunnels.ts). Относительный './client' обходил jest-маппер
// '^@/api/client\$' — и первый же компонент, импортировавший templatesApi
// (модалка генерации, WEB-1783), уронил 13 чужих тест-наборов синтаксисом
// import.meta из настоящего клиента.
import { api } from '@/api/client';
import type { QuizTemplate, PaywallTemplate } from '@/types';

export const templatesApi = {
  getQuizTemplates: (filters?: { category?: string; language?: string }) =>
    api.get<QuizTemplate[]>('/quiz-templates', { params: filters }).then((r) => r.data),

  getQuizTemplateById: (id: string) =>
    api.get<QuizTemplate>(`/quiz-templates/${id}`).then((r) => r.data),

  createQuizFromTemplate: (projectId: string, tid: string) =>
    api.post(`/projects/${projectId}/quizzes/from-template/${tid}`).then((r) => r.data),

  getPaywallTemplates: (filters?: { category?: string; language?: string }) =>
    api.get<PaywallTemplate[]>('/paywall-templates', { params: filters }).then((r) => r.data),

  getPaywallTemplateById: (id: string) =>
    api.get<PaywallTemplate>(`/paywall-templates/${id}`).then((r) => r.data),

  createPaywallFromTemplate: (projectId: string, tid: string) =>
    api.post(`/projects/${projectId}/paywalls/from-template/${tid}`).then((r) => r.data),
};
